/* eslint-disable import/no-cycle */
import { fetchPerformance } from "apis/performance";
import moment from "moment";
import { put, takeEvery } from "redux-saga/effects";
import { performanceAction } from "redux/slice/performance";
import { enqueueSnackbar } from "notistack";
// import _ from "lodash";

export function* getPerformanceSaga(action) {
  try {
    const info = yield fetchPerformance(action.payload);

    if (info?.data?.success) {
      const usersTimezone = action.payload.timezone || moment.tz.guess();
      const endDate = moment.tz(action.payload.endDate, usersTimezone).format("YYYY-MM-DD");

      const { data } = info.data;

      if (action?.payload?.dateType === 1) {
        data?.reportingUsers?.forEach((user) => {
          const allKpiWithDates = [];
          user?.kpiActiontotal?.forEach((activity) => {
            allKpiWithDates.push(activity);
          });
          const totalPerformance = [];

          for (
            let startDate = moment.tz(action.payload.startDate, usersTimezone).format("YYYY-MM-DD");
            startDate <= endDate;
            startDate = moment(startDate).add(1, "d").format("YYYY-MM-DD")
          ) {
            const kpiPoints = allKpiWithDates
              .filter(
                (kpi) =>
                  moment.tz(kpi.createdAt, usersTimezone).format("YYYY-MM-DD") ===
                  moment(startDate).format("YYYY-MM-DD")
              )
              .reduce(
                (kpiDetails, kpi) => ({
                  totalPoints: parseInt(kpiDetails.totalPoints, 10) + parseInt(kpi.totalPoints, 10),
                  totalCounts: parseInt(kpiDetails.totalCounts, 10) + parseInt(kpi.totalCounts, 10),
                }),
                {
                  totalPoints: 0,
                  totalCounts: 0,
                }
              );

            totalPerformance.push({
              date: moment(startDate).format("YYYY-MM-DD"),
              points: kpiPoints.totalPoints,
              count: kpiPoints.totalCounts,
              dailyTarget: user?.outOfOffice?.includes?.(moment(startDate).format("YYYY-MM-DD"))
                ? 0
                : parseInt(data.companyDailyTarget, 10),
            });
          }
          user.totalPerformance = totalPerformance;
        });
      } else {
        const startDate = moment.tz(action.payload.startDate, usersTimezone).format("YYYY-MM-DD");

        const months = [];

        // Gather month info
        let tmp = moment(startDate);
        while (moment(tmp).startOf("month") <= moment(endDate).startOf("month")) {
          const start = tmp.isSame(moment(startDate))
            ? moment(startDate)
            : moment(tmp).startOf("month");
          const end = tmp > moment(endDate) ? moment(endDate) : moment(tmp).endOf("month");
          months.push({
            dateValue: tmp.format("YYYY-MM"),
            start,
            end,
          });
          tmp = tmp.add(1, "M");
        }

        data?.reportingUsers?.forEach((user) => {
          const allKpiWithMonth = [];
          user?.kpiActiontotal?.forEach((activity) => {
            allKpiWithMonth.push(activity);
          });
          const totalPerformance = [];

          months.forEach((month) => {
            const kpiPoints = allKpiWithMonth
              .filter((kpi) => kpi.createdAt === month.dateValue)
              .reduce(
                (kpiDetails, kpi) => ({
                  totalPoints: parseInt(kpiDetails.totalPoints, 10) + parseInt(kpi.totalPoints, 10),
                  totalCounts: parseInt(kpiDetails.totalCounts, 10) + parseInt(kpi.totalCounts, 10),
                }),
                {
                  totalPoints: 0,
                  totalCounts: 0,
                }
              );

            const target =
              Math.abs(month.end.diff(month.start, "days") + 1) * parseInt(user.dailyTarget, 10);

            totalPerformance.push({
              date: month.dateValue,
              points: kpiPoints.totalPoints,
              count: kpiPoints.totalCounts,
              dailyTarget: target,
            });
          });

          user.totalPerformance = totalPerformance;
        });
      }

      yield put(
        performanceAction.getPerformanceSuccess({
          data,
        })
      );
    } else {
      yield put(
        performanceAction.getPerformanceFailed({
          errorMessage:
            info?.response?.status === 403
              ? ""
              : info?.response?.data?.message || "Something went wrong",
        })
      );
    }
  } catch (error) {
    enqueueSnackbar(
      JSON.stringify({
        icon: "error",
        title: "Error",
        text: error.message || "Something went wrong",
      }),
      {
        variant: "custom",
      }
    );
    yield put(performanceAction.getPerformanceFailed());
  }
}
export function* watchPerformanceAsync() {
  yield takeEvery(performanceAction.getPerformanceRequest, getPerformanceSaga);
}
